import { useQuery } from '@tanstack/react-query'

import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  fetchAssignedBijlagenForEntity,
  initialState,
} from '../services/fetchAssignedBijlagenForEntity'

export { useAssignedBijlagenForEntity, queryKey }

const queryKey = 'entity-assigned-bijlagen'

const useAssignedBijlagenForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchAssignedBijlagenForEntity(entity),
    queryKey: [queryKey, entity],
    enabled: hasPermissions && !!entity.id,
  })

  return {
    data: data || initialState.data,
  }
}
